import script from "./AssistantChatWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssistantChatWidget.vue?vue&type=script&lang=ts&setup=true"

import "./AssistantChatWidget.vue?vue&type=style&index=0&id=5fd649a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd649a0"]])

export default __exports__